export default "__VITE_ASSET__CBWNihNI__"